package com.example.mystybag.login.logic

import com.example.mystybag.common.logic.NavigatorStaffResetPassword
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.Response
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.isValidEmail
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.login.model.StaffForgotPasswordEmailUIState
import com.example.mystybag.sharedmodels.project.requestModels.merchant.ForgotPasswordStaffRequestModel
import com.example.mystybag.common.resources.SR
import kotlinx.coroutines.launch

class StaffForgotPasswordEmailViewModel(
    context: AppContext
) : ChildViewModel<StaffForgotPasswordEmailUIState>(context, StaffForgotPasswordEmailUIState()) {

    override fun onCreate() {
        navControls.backButtonVisible = true
        navControls.title = ""
    }

    fun onEmailChange(email: String) {
        updateState { it.copy(email = email, emailIsError = false, emailErrorMsg = "") }
    }

    fun onContinue() {
        if (validate()) {
            scope.launch {
                updateState { it.copy(isLoading = true) }

                commandBlock(showProgress = true) {
                    CommonCommands.forgotPasswordStaff(
                        ForgotPasswordStaffRequestModel(email = uiState.value.email)
                    )
                        .onResponse(
                            success = { response ->
                                launchOnMain {
                                    updateState { it.copy(isLoading = false) }
                                    showSnackbar(sharedString(SR.strings.forgot_password_email_sent))
                                    navigate(
                                        NavigatorStaffResetPassword(
                                            email = uiState.value.email,
                                            temporaryPassword = ""
                                        )
                                    )
                                }
                            },
                            baseError = { response ->
                                launchOnMain {
                                    updateState { it.copy(isLoading = false) }
                                    showSnackbar(Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                                }
                            }
                        )
                }
            }
        }
    }

    private fun validate(): Boolean {
        var isValid = true
        val state = uiState.value

        if (state.email.isEmpty() || !state.email.isValidEmail) {
            updateState {
                it.copy(
                    emailIsError = true,
                    emailErrorMsg = sharedString(SR.strings.please_enter_valid_email_address)
                )
            }
            isValid = false
        }

        return isValid
    }
}
